import { Component, Input } from '@angular/core';
import { Content } from 'lingo2-models';

@Component({
  selector: 'app-content-card-mini-list',
  templateUrl: './content-card-mini-list.component.html',
  styleUrls: ['./content-card-mini-list.component.scss'],
})
export class ContentCardMiniListComponent {
  @Input() items: Content[] = [];

  // функция для трекинга списка, чтобы он не 'моргал'
  public trackByFn(index, item: Content): string {
    return item.id;
  }
}
